<app-export-snackbar
	(complete)="onComplete()"
	(openDetails)="onOpenDetails()"
	[runningExports]="runningExports"
	[failedExports]="failedExports"
	[hasRunningExports]="hasRunningExports"
	[hasFailedExports]="hasFailedExports"
	[isDetailsDialogOpen]="isDialogOpen"
></app-export-snackbar>
